// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3fqrp","actionsCol":"EnrolledClinics_actionsCol__1Qky-"};